import React from 'react';
import { ProjectStatus } from '../../../utils/utils';
import {
    ProgressBarSaved,
    ProgressBarProposed,
    ProgressBarDeclined,
    ProgressBarAccepted,
    ProgressBarRegistered,
    ProgressBarHandedIn,
    ProgressBarEvaluated,
    ProgressBarFailed,
    ProgressBarWithdrawn,
} from './ProgressBars';
import './ProjectProgressBar.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { ILocalization } from '../../../localization/definitions/types';

interface ProjectProgressBarProps {
    currentStatus: ProjectStatus;
}

export const ProjectProgressBar: React.FC<ProjectProgressBarProps> = ({
    currentStatus,
}): JSX.Element => {
    const localization: ILocalization = useSelector(
        (state: RootState) => state.localization
    );
    const progressBarDisplay = {
        [ProjectStatus.saved]: <ProgressBarSaved />,
        [ProjectStatus.pending]: <ProgressBarProposed />,
        [ProjectStatus.declined]: <ProgressBarDeclined />,
        [ProjectStatus.approved]: <ProgressBarAccepted />,
        [ProjectStatus.registered]: <ProgressBarRegistered />,
        [ProjectStatus.handedIn]: <ProgressBarHandedIn />,
        [ProjectStatus.evaluated]: (
            <ProgressBarEvaluated
                evaluatedString={
                    localization.localizationStrings.susy.shared
                        .projectProgressBar.evaluated
                }
            />
        ),
        [ProjectStatus.failed]: <ProgressBarFailed />,
        [ProjectStatus.withdrawn]: <ProgressBarWithdrawn />,
    };

    return (
        <React.Fragment>
            <div
                data-testid='project-progress-bar'
                className='d-flex project-progress-bar-wrapper flex-wrap'
            >
                {progressBarDisplay[currentStatus]}
            </div>
        </React.Fragment>
    );
};
